module.exports = __webpack_public_path__ + "clubhouse-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/clubhouse-logo.png
// module id = 1253
// module chunks = 74